import React, { useEffect, useState } from 'react'
import 'react-multi-carousel/lib/styles.css'
import 'bootstrap/dist/css/bootstrap.css'
import './train.css'
import dayjs from 'dayjs'
import Footer from '../common/footer/Footer'
import Header from '../common/header/Header'
import PropTypes from 'prop-types'
import Tabs from '@mui/material/Tabs'
import Tab from '@mui/material/Tab'
import Typography from '@mui/material/Typography'
import {
  Box,
  Menu,
  Button,
  MenuItem,
  OutlinedInput,
  InputAdornment,
  Avatar,
  Popper,
} from '@mui/material'
import Carousel from 'react-multi-carousel'
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { Link, useNavigate } from 'react-router-dom'
import { airports, searchTrains } from '../../api/airport'
import { FormControl } from '@mui/material'
import { flightBooking } from '../../api/flight'
import { ToastContainer, toast } from 'react-toastify'
import { trianBooking } from '../../api/train'
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import { renderTimeViewClock } from '@mui/x-date-pickers/timeViewRenderers';
import { packageCity, packageGet } from '../../api/package'
// -------------------------------------------------
// const PopperStyle = styled(Popper, { shouldForwardProp })(({ theme }) => ({
//   zIndex: 1100,
//   width: '99%',
//   top: '-55px !important',
//   padding: '0 12px',
//   [theme.breakpoints.down('sm')]: {
//     padding: '0 10px',
//   },
// }))

// const OutlineInputStyle = styled(OutlinedInput, { shouldForwardProp })(
//   ({ theme }) => ({
//     width: 434,
//     marginLeft: 16,
//     paddingLeft: 16,
//     paddingRight: 16,
//     '& input': {
//       background: 'transparent !important',
//       paddingLeft: '4px !important',
//     },
//     [theme.breakpoints.down('lg')]: {
//       width: 250,
//     },
//     [theme.breakpoints.down('md')]: {
//       width: '100%',
//       marginLeft: 4,
//       background: '#fff',
//     },
//   }),
// )

// const HeaderAvatarStyle = styled(Avatar, { shouldForwardProp })(
//   ({ theme }) => ({
//     ...theme.typography.commonAvatar,
//     ...theme.typography.mediumAvatar,
//     background: theme.palette.secondary.light,
//     color: theme.palette.secondary.dark,
//     '&:hover': {
//       background: theme.palette.secondary.dark,
//       color: theme.palette.secondary.light,
//     },
//   }),
// )

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  )
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
}

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  }
}

const destination = {
  superLargeDesktop: {
    breakpoint: { max: 4000, min: 3000 },
    items: 4,
    slidesToSlide: 1,
  },
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 4,
    slidesToSlide: 1,
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 2,
    slidesToSlide: 1,
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 1,
    slidesToSlide: 1,
  },
}

const Train = () => {
  const navigate = useNavigate()
  const [anchorEl, setAnchorEl] = React.useState(null);
  const openB = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget)
  }
  const handleClose = () => {
    setAnchorEl(null)
  }
  const [value, setValue] = React.useState(0)
  const notify = (message) => toast(message)
  const handleChange = (event, newValue) => {
    setValue(newValue)
    if (newValue === 0) {
      setFlighDetails({
        from: '',
        to: '',
        departureDate: '',
        returnDate: '',
        passengerCount: {
          adult: 0,
          seniorCitizen: 0,
          child: 0
        },
        pickupTime: '',
        returnTime: '',
        type: 'One Way' || '',
        trainType: '',
      })
    } else if (newValue === 1) {
      setFlighDetails({
        from: '',
        to: '',
        departureDate: '',
        returnDate: '',
        passengerCount: {
          adult: 0,
          seniorCitizen: 0,
          child: 0
        },
        pickupTime: '',
        returnTime: '',
        type: 'Round Trip' || '',
        trainType: '',
      })
    }
  }
  const [airport, setAirport] = useState([])
  const [airport1, setAirport1] = useState([])
  const getAirports = async (val) => {
    const resp = await searchTrains({ search: val })

    setAirport1(resp.data)
  }

  const getAirportSearch = async (val) => {
    const resp = await searchTrains({ search: val })

    setAirport(resp.data)
  }

  const [inputValue, setInputValue] = React.useState('')
  const [inputValue1, setInputValue1] = React.useState('')

  const newFrom = airport?.map((items) => {
    return { label: items.name + '(' + items.code + ')', value: items.name }
  })


  useEffect(() => {
    getAirports('.')
  }, [])

  useEffect(() => {
    console.log(inputValue)

    console.log('We are here')
    getAirportSearch('.')
  }, [])

  const [flightDetails, setFlighDetails] = useState({
    from: '',
    to: '',
    departureDate: '',
    returnDate: '',
    passengerCount: {
      adult: 0,
      seniorCitizen: 0,
      child: 0
    },
    pickupTime: '',
    returnTime: '',
    type: 'One Way' || '',
    trainType: '',
  })

  const [count, setCount] = useState(0)

  useEffect(() => {
    if (count === 0) {
      setFlighDetails({
        ...flightDetails,
        passengerCount: { ...flightDetails.passengerCount, adult: 0 },
      })
    } else {
      setFlighDetails({
        ...flightDetails,
        passengerCount: { ...flightDetails.passengerCount, adult: count }
      })
    }
  }, [count])
  const [child, setChild] = useState(0)

  useEffect(() => {
    if (child === 0) {
      setFlighDetails({
        ...flightDetails,
        passengerCount: { ...flightDetails.passengerCount, child: 0 },
      })
    } else {
      setFlighDetails({
        ...flightDetails,
        passengerCount: { ...flightDetails.passengerCount, child: child },
      })
    }
  }, [child])
  const [seniorCitizen, setSeniorCitizen] = useState(0)

  useEffect(() => {
    if (seniorCitizen === 0) {
      setFlighDetails({
        ...flightDetails,
        passengerCount: { ...flightDetails.passengerCount, seniorCitizen: 0 },
      })
    } else {
      setFlighDetails({
        ...flightDetails,
        passengerCount: { ...flightDetails.passengerCount, seniorCitizen: seniorCitizen },
      })
    }
  }, [seniorCitizen])

  const newTo = airport1
    ?.filter((item) => {
      return item?.name !== flightDetails?.from
    })
    .map((items) => {
      return { label: items.name + '(' + items.code + ')', value: items.name }
    })

  function checkEmptyKeys(obj) {
    for (const key in obj) {
      if (obj[key] === '' || obj[key] === 0) {
        return true
      }
    }
    return false
  }

  const token = localStorage.getItem('token')
  console.log(checkEmptyKeys(flightDetails))
  const submit = async () => {
    if (token) {
      if (flightDetails.type === 'One Way') {
        delete flightDetails.returnDate
        delete flightDetails.returnTime
        if (flightDetails.departureDate === '') {
          notify('Departure Date is required')
        } else if (flightDetails.pickupTime === '') {
          notify('Departure time is required')
        } else if (flightDetails.from === '') {
          notify('From is required')
        } else if (flightDetails.to === '') {
          notify('To is required')
        } else if (flightDetails.passengerCount.adult === 0) {
          notify('Adult Count is required')
        } else if (flightDetails.trainType === '') {
          notify('Train Type is required')
        } else if (flightDetails.type === '') {
          notify('Type is required')
        } else {
          try {
            const resp = await trianBooking(flightDetails)
            if (resp.code === 201) {
              notify(resp.message)
              handleChange(null, 0)
              setCount(0)
            } else {
              notify(resp.message)
              handleChange(null, 0)
              setCount(0)
            }
          } catch (error) {
            notify(error.message)
            handleChange(null, 0)
            setCount(0)
          }
        }
      } else {
        if (flightDetails.departureDate === '') {
          notify('Departure Date is required')
        } else if (flightDetails.pickupTime === '') {
          notify('Departure time is required')
        } else if (flightDetails.returnDate === '') {
          notify('Return Date is required')
        } else if (flightDetails.returnTime === '') {
          notify('Return time is required')
        } else if (flightDetails.from === '') {
          notify('From is required')
        } else if (flightDetails.to === '') {
          notify('To is required')
        } else if (flightDetails.passengerCount.adult === 0) {
          notify('Adult Count is required')
        } else if (flightDetails.trainType === '') {
          notify('Train Type is required')
        } else if (flightDetails.type === '') {
          notify('Type is required')
        } else {
          try {
            const resp = await trianBooking(flightDetails)
            if (resp.code === 201) {
              notify(resp.message)
              handleChange(null, 0)
              setCount(0)
            } else {
              notify(resp.message)
              handleChange(null, 0)
              setCount(0)
            }
          } catch (error) {
            notify(error.message)
            handleChange(null, 0)
            setCount(0)
          }
        }
      }
    } else {
      notify('Please Login for booking')
    }
  }
  const tomorrow = dayjs()

  useEffect(() => {
    if (value) {
      setCount(0)
    }
  }, [value])

  const [tourDetail, setTourDetail] = useState({
    city: '',
    type: ''
  })

  const [tourData, setTourData] = useState([])
  const [tourInternationalData, setTourInternationalData] = useState([])
  const getPackages = async () => {
    if (tourDetail.type === '') {
      alert('Please fill type')
    } else if (tourDetail.city === '') {
      alert('Please fill City')
    } else {
      const resp = await packageGet(tourDetail)
      const filterInterNational = resp.data?.filter((item) => {
        return item?.packageMode === 'International'
      })
      const national = resp.data?.filter((item) => {
        return item?.packageMode === 'National'
      })
      setTourInternationalData(filterInterNational)
      setTourData(national)
    }
  }


  const getPackage = async () => {
    const resp = await packageGet()
    const filterInterNational = resp.data?.filter((item) => {
      return item?.packageMode === 'International'
    })
    const national = resp.data?.filter((item) => {
      return item?.packageMode === 'National'
    })
    setTourInternationalData(filterInterNational)
    setTourData(national)
  }

  useEffect(() => {
    getPackage()
  }, [])

  const [active, setActive] = useState('')
  const [activeReturn, setActiveReturn] = useState('')
  const [activeDep, setActiveDep] = useState('')

  console.log(flightDetails)
  return (
    <>
      <Header />
      <section className="">
        <div className="container">
          <div className="mainBannerSectionTrain">
            <div className="row">
              <div className="col-md-11 mx-auto text-center">
                <h1 className="text-dark display-3 pt-sm-5 my-5">
                  Book Instant Train Tickets for all Worldwide
                </h1>
              </div>
            </div>
            <Box
              sx={{
                width: '100%',
                backgroundColor: '#fff',
                borderRadius: '10px',
              }}
            >
              <Box
                className="tabSection"
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  padding: '20px 25px 0px 25px',
                }}
              >
                <Tabs
                  value={value}
                  onChange={handleChange}
                  aria-label="basic tabs example"
                >
                  <Tab label="One Way" {...a11yProps(0)} />
                  <Tab label="Round Trip" {...a11yProps(1)} />
                </Tabs>
                <div className="selectSection">
                  <Autocomplete
                    className="w-1"
                    sx={{ width: '45%', mx: 2 }}
                    size="small"
                    disablePortal
                    id="combo-box-demo"
                    value={flightDetails.trainType}
                    getOptionLabel={(option) => {
                      if (option.label) {
                        return option.label
                      } else if (typeof option === 'string') {
                        return option
                      } else {
                        return ''
                      }
                    }}
                    isOptionEqualToValue={(option, value) => {
                      if (option.value && value.value) {
                        return option.value === value.value
                      } else {
                        return false
                      }
                    }}
                    options={flightTypes}
                    onChange={(e, newValue) => {
                      if (newValue !== null) {
                        setFlighDetails({
                          ...flightDetails,
                          trainType: newValue.value,
                        })
                      } else {
                        return;
                      }

                    }}
                    renderInput={(params) => (
                      <TextField {...params} label="Select Train Type" />
                    )}
                  />


                  <div className="guestBox">
                    <Button
                      id="basic-button"
                      aria-controls={openB ? 'basic-menu' : undefined}
                      aria-haspopup="true"
                      aria-expanded={openB ? 'true' : undefined}
                      onClick={handleClick}
                      className="guestBtn"
                    >
                      Passenger Count : {flightDetails.passengerCount.adult + flightDetails.passengerCount.child + flightDetails.passengerCount.seniorCitizen}
                    </Button>
                    <Menu
                      id="basic-menu"
                      anchorEl={anchorEl}
                      open={openB}
                      onClose={handleClose}
                      MenuListProps={{
                        'aria-labelledby': 'basic-button',
                      }}
                    >
                      <MenuItem className="muiB">
                        <ul
                          class="dropdown-menu guest-selector-dropdown show"
                          style={{
                            position: 'absolute',
                            inset: '0px auto auto 0px',
                            margin: '0px',
                          }}
                          data-popper-placement="bottom-start"
                        >
                          <li class="d-flex justify-content-between">
                            <div>
                              <h6 class="mb-0">Adult</h6>
                            </div>
                            <div class="hstack gap-1 align-items-center">
                              <button
                                onClick={() => {
                                  if (count > 0) {
                                    setCount(count - 1)
                                  } else {
                                    setFlighDetails({
                                      ...flightDetails,
                                      passengerCount: { ...flightDetails.passengerCount, adult: 0 }
                                    })
                                  }
                                }}
                                class="btn btn-md btn-link adult-remove p-0 mb-0"
                                type="button"
                              >
                                <svg
                                  width="1em"
                                  height="1em"
                                  viewBox="0 0 16 16"
                                  fill="currentColor"
                                  role="img"
                                  focusable="false"
                                  class="fs-5 fa-fw"
                                >
                                  <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"></path>
                                  <path d="M4 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 4 8"></path>
                                </svg>
                              </button>
                              <h6 class="guest-selector-count mb-0 child">
                                {flightDetails?.passengerCount.adult}
                              </h6>
                              <button
                                onClick={() => {
                                  setCount(count + 1)
                                }}
                                class="btn btn-md btn-link adult-add p-0 mb-0"
                                type="button"
                              >
                                <svg
                                  width="1em"
                                  height="1em"
                                  viewBox="0 0 16 16"
                                  fill="currentColor"
                                  role="img"
                                  focusable="false"
                                  class="fs-5 fa-fw"
                                >
                                  <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"></path>
                                  <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4"></path>
                                </svg>
                              </button>
                            </div>
                          </li>
                          <li class="d-flex justify-content-between">
                            <div>
                              <h6 class="mb-0">Child</h6>
                            </div>
                            <div class="hstack gap-1 align-items-center">
                              <button
                                onClick={() => {
                                  console.log('here')
                                  if (child > 0) {
                                    setChild(child - 1)
                                  } else {
                                    setFlighDetails({
                                      ...flightDetails,
                                      passengerCount: { ...flightDetails.passengerCount, child: 0 }
                                    })
                                  }
                                }}
                                class="btn btn-md btn-link adult-remove p-0 mb-0"
                                type="button"
                              >
                                <svg
                                  width="1em"
                                  height="1em"
                                  viewBox="0 0 16 16"
                                  fill="currentColor"
                                  role="img"
                                  focusable="false"
                                  class="fs-5 fa-fw"
                                >
                                  <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"></path>
                                  <path d="M4 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 4 8"></path>
                                </svg>
                              </button>
                              <h6 class="guest-selector-count mb-0 child">
                                {flightDetails?.passengerCount.child}
                              </h6>
                              <button
                                onClick={() => {
                                  setChild(child + 1)
                                }}
                                class="btn btn-md btn-link adult-add p-0 mb-0"
                                type="button"
                              >
                                <svg
                                  width="1em"
                                  height="1em"
                                  viewBox="0 0 16 16"
                                  fill="currentColor"
                                  role="img"
                                  focusable="false"
                                  class="fs-5 fa-fw"
                                >
                                  <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"></path>
                                  <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4"></path>
                                </svg>
                              </button>
                            </div>
                          </li>
                          <li class="d-flex justify-content-between">
                            <div>
                              <h6 class="mb-0">Senior Citizen</h6>
                            </div>
                            <div class="hstack gap-1 align-items-center">
                              <button
                                onClick={() => {
                                  if (seniorCitizen > 0) {
                                    setSeniorCitizen(seniorCitizen - 1)
                                  } else {
                                    setFlighDetails({
                                      ...flightDetails,
                                      passengerCount: { ...flightDetails.passengerCount, seniorCitizen: 0 }
                                    })
                                  }
                                }}
                                class="btn btn-md btn-link adult-remove p-0 mb-0"
                                type="button"
                              >
                                <svg
                                  width="1em"
                                  height="1em"
                                  viewBox="0 0 16 16"
                                  fill="currentColor"
                                  role="img"
                                  focusable="false"
                                  class="fs-5 fa-fw"
                                >
                                  <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"></path>
                                  <path d="M4 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 4 8"></path>
                                </svg>
                              </button>
                              <h6 class="guest-selector-count mb-0 child">
                                {flightDetails?.passengerCount.seniorCitizen}
                              </h6>
                              <button
                                onClick={() => {
                                  setSeniorCitizen(seniorCitizen + 1)
                                }}
                                class="btn btn-md btn-link adult-add p-0 mb-0"
                                type="button"
                              >
                                <svg
                                  width="1em"
                                  height="1em"
                                  viewBox="0 0 16 16"
                                  fill="currentColor"
                                  role="img"
                                  focusable="false"
                                  class="fs-5 fa-fw"
                                >
                                  <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"></path>
                                  <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4"></path>
                                </svg>
                              </button>
                            </div>
                          </li>
                        </ul>
                      </MenuItem>
                    </Menu>
                  </div>
                </div>
              </Box>
              <CustomTabPanel value={value} index={0}>
                <div className="row">
                  <div className="col-md-6 col-lg-3">
                    <div className="form-border-transparent form-fs-lg bg-light rounded-3 h-100 p-3">
                      <label className="mb-1">
                        <i className="fa-solid fa-location-dot"></i> From
                      </label>
                      <Autocomplete
                        size="small"
                        getOptionLabel={(option) => {
                          if (option.label) {
                            return option.label
                          } else if (typeof option === 'string') {
                            return option
                          } else {
                            return ''
                          }
                        }}
                        isOptionEqualToValue={(option, value) => {
                          if (option.value && value.value) {
                            return option.value === value.value
                          } else {
                            return false
                          }
                        }}
                        sx={{ mt: 1 }}
                        disablePortal
                        id="combo-box-demo"
                        options={newFrom}
                        value={flightDetails.from}
                        onChange={(e, newValue) => {
                          if (newValue !== null) {
                            setFlighDetails({
                              ...flightDetails,
                              from: newValue.value,
                            })
                          } else {
                            return
                          }
                        }}
                        inputValue={inputValue}
                        onInputChange={(event, newInputValue) => {
                          setInputValue(newInputValue)
                        }}
                        renderInput={(params) => (
                          <TextField {...params} label="Select Location" />
                        )}
                      />

                    </div>
                  </div>
                  <div className="col-md-6 col-lg-3">
                    <div className="form-border-transparent form-fs-lg bg-light rounded-3 h-100 p-3">
                      <label className="mb-1">
                        <i className="fa-solid fa-location-arrow"></i> To
                      </label>
                      <Autocomplete
                        size="small"
                        sx={{ mt: 1 }}
                        disablePortal
                        id="combo-box-demo"
                        options={newTo}
                        getOptionLabel={(option) => {
                          if (option.label) {
                            return option.label
                          } else if (typeof option === 'string') {
                            return option
                          } else {
                            return ''
                          }
                        }}
                        isOptionEqualToValue={(option, value) => {
                          if (option.value && value.value) {
                            return option.value === value.value
                          } else {
                            return false
                          }
                        }}
                        value={flightDetails.to}
                        onChange={(e, newValue) => {
                          if (newValue !== null) {
                            setFlighDetails({
                              ...flightDetails,
                              to: newValue.value,
                            })
                          } else {
                            return
                          }
                        }}
                        inputValue={inputValue1}
                        onInputChange={(event, newInputValue) => {
                          setInputValue1(newInputValue)
                        }}
                        renderInput={(params) => (
                          <TextField {...params} label="Select Location" />
                        )}
                      />
                    </div>
                  </div>
                  <div className="col-md-6 col-lg-3 dateCol">
                    <div className="form-border-transparent form-fs-lg bg-light rounded-3 h-100 p-3">
                      <label className="mb-1">
                        <i className="fa-solid fa-calendar"></i> Departure Time
                      </label>
                      {/* <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DemoContainer components={['TimePicker']}>
                          <TimePicker
                            slotProps={{ textField: { size: 'small' } }}
                            label="Departure Time"
                            viewRenderers={{
                              hours: renderTimeViewClock,
                              minutes: renderTimeViewClock,
                              seconds: renderTimeViewClock,
                            }}
                            value={flightDetails.pickupTime}
                            onChange={(newValue) => {
                              console.log(newValue)
                              const date = new Date(newValue['$d'])

                              setFlighDetails({
                                ...flightDetails,
                                pickupTime: new Date(date).getTime(),
                              })
                            }}
                          />
                        </DemoContainer>
                      </LocalizationProvider> */}
                      <div className="timeSlotsOuter">
                        <div
                          onClick={() => {


                            setFlighDetails({
                              ...flightDetails,
                              pickupTime: 'before 6 AM',
                            })

                            setActive('before 6 AM')
                          }}
                          className={active === 'before 6 AM' ? "appendBottom12 filterTimeSlots activeTime" : "appendBottom12 filterTimeSlots"}>
                          <img className="checkBlockIcon" src='images/morning_inactive.webp' alt='' />
                          <div className="boldFont">Before <b>6</b> AM</div>
                        </div>
                        <div
                          onClick={() => {

                            setFlighDetails({
                              ...flightDetails,
                              pickupTime: '6 AM - 12 PM',
                            })
                            setActive('6 AM - 12 PM')

                          }}
                          className={active === '6 AM - 12 PM' ? "appendBottom12 filterTimeSlots activeTime" : "appendBottom12 filterTimeSlots"}>

                          <img className="checkBlockIcon" src='images/noon_inactive.webp' alt='' />
                          <div className="boldFont"><b>6</b> AM - <b>12</b> PM</div>
                        </div>
                        <div
                          onClick={() => {
                            setFlighDetails({
                              ...flightDetails,
                              pickupTime: '12 PM - 6 PM',
                            })
                            setActive('12 PM - 6 PM')
                          }}
                          className={active === '12 PM - 6 PM' ? "appendBottom12 filterTimeSlots activeTime" : "appendBottom12 filterTimeSlots"}>

                          <img className="checkBlockIcon" src='images/evening_inactive.webp' alt='' />
                          <div className="boldFont"><b>12</b> PM - <b>6</b> PM</div>
                        </div>
                        <div
                          onClick={() => {
                            setFlighDetails({
                              ...flightDetails,
                              pickupTime: 'after 6 PM',
                            })
                            setActive('after 6 PM')
                          }}
                          className={active === 'after 6 PM' ? "appendBottom12 filterTimeSlots activeTime" : "appendBottom12 filterTimeSlots"}>

                          <img className="checkBlockIcon" src='images/night_inactive.webp' alt='' />
                          <div className="boldFont">After <br /><b>6</b> PM</div>
                        </div>
                      </div>





                    </div>
                  </div>
                  <div className="col-md-6 col-lg-3 dateCol">
                    <div className="form-border-transparent form-fs-lg bg-light rounded-3 h-100 p-3 daeSection">
                      <label className="mb-1">
                        <i className="fa-solid fa-calendar"></i> Departure Date
                      </label>
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DemoContainer components={['DatePicker']}>
                          <DatePicker
                            label="Select Date"
                            minDate={tomorrow}
                            slotProps={{ textField: { size: 'small' } }}
                            value={flightDetails.departureDate}
                            onChange={(newValue) => {
                              const date = new Date(newValue['$d'])

                              setFlighDetails({
                                ...flightDetails,
                                departureDate: date,
                              })
                            }}
                          />
                        </DemoContainer>
                      </LocalizationProvider>
                    </div>
                  </div>
                  <div className="col-12 text-end">
                    <button onClick={submit} className="btn btn-primary mb-n4">
                      Book Now <i className="fa-solid fa-arrow-right"></i>
                    </button>
                  </div>
                </div>
              </CustomTabPanel>
              <CustomTabPanel value={value} index={1}>
                <div className="row">
                  <div className="col-md-6 col-lg-2">
                    <div className="form-border-transparent form-fs-lg bg-light rounded-3 h-100 p-3">
                      <label className="mb-1">
                        <i className="fa-solid fa-location-dot"></i> From
                      </label>
                      <Autocomplete
                        size="small"
                        sx={{ mt: 1 }}
                        disablePortal
                        getOptionLabel={(option) => {
                          if (option.label) {
                            return option.label
                          } else if (typeof option === 'string') {
                            return option
                          } else {
                            return ''
                          }
                        }}
                        isOptionEqualToValue={(option, value) => {
                          if (option.value && value.value) {
                            return option.value === value.value
                          } else {
                            return false
                          }
                        }}
                        id="combo-box-demo"
                        options={newFrom}
                        value={flightDetails.from}
                        onChange={(e, newValue) => {
                          if (newValue !== null) {
                            setFlighDetails({
                              ...flightDetails,
                              from: newValue.value,
                            })
                          } else {
                            return
                          }
                        }}
                        inputValue={inputValue}
                        onInputChange={(event, newInputValue) => {
                          setInputValue(newInputValue)
                        }}
                        renderInput={(params) => (
                          <TextField {...params} label="Select Location" />
                        )}
                      />
                    </div>
                  </div>
                  <div className="col-md-6 col-lg-2">
                    <div className="form-border-transparent form-fs-lg bg-light rounded-3 h-100 p-3">
                      <label className="mb-1">
                        <i className="fa-solid fa-location-arrow"></i> To
                      </label>
                      <Autocomplete
                        size="small"
                        sx={{ mt: 1 }}
                        disablePortal
                        id="combo-box-demo"
                        getOptionLabel={(option) => {
                          if (option.label) {
                            return option.label
                          } else if (typeof option === 'string') {
                            return option
                          } else {
                            return ''
                          }
                        }}
                        isOptionEqualToValue={(option, value) => {
                          if (option.value && value.value) {
                            return option.value === value.value
                          } else {
                            return false
                          }
                        }}
                        options={newTo}
                        value={flightDetails.to}
                        onChange={(e, newValue) => {
                          if (newValue !== null) {
                            setFlighDetails({
                              ...flightDetails,
                              to: newValue.value,
                            })
                          } else {
                            return
                          }
                        }}
                        inputValue={inputValue1}
                        onInputChange={(event, newInputValue) => {
                          setInputValue1(newInputValue)
                        }}
                        renderInput={(params) => (
                          <TextField {...params} label="Select Location" />
                        )}
                      />
                    </div>
                  </div>
                  <div className="col-md-6 col-lg-2 dateCol">
                    <div className="form-border-transparent form-fs-lg bg-light rounded-3 h-100 p-3">
                      <label className="mb-1">
                        <i className="fa-solid fa-calendar"></i> Departure Time
                      </label>
                      <div className="timeSlotsOuter">
                        <div
                          onClick={() => {


                            setFlighDetails({
                              ...flightDetails,
                              pickupTime: 'before 6 AM',
                            })

                            setActiveDep('before 6 AM')
                          }}
                          className={activeDep === 'before 6 AM' ? "appendBottom12 filterTimeSlots activeTime" : "appendBottom12 filterTimeSlots"}>
                          <img className="checkBlockIcon" src='images/morning_inactive.webp' alt='' />
                          <div className="boldFont">Before <b>6</b> AM</div>
                        </div>
                        <div
                          onClick={() => {

                            setFlighDetails({
                              ...flightDetails,
                              pickupTime: '6 AM - 12 PM',
                            })
                            setActiveDep('6 AM - 12 PM')

                          }}
                          className={activeDep === '6 AM - 12 PM' ? "appendBottom12 filterTimeSlots activeTime" : "appendBottom12 filterTimeSlots"}>

                          <img className="checkBlockIcon" src='images/noon_inactive.webp' alt='' />
                          <div className="boldFont"><b>6</b> AM - <b>12</b> PM</div>
                        </div>
                        <div
                          onClick={() => {
                            setFlighDetails({
                              ...flightDetails,
                              pickupTime: '12 PM - 6 PM',
                            })
                            setActiveDep('12 PM - 6 PM')
                          }}
                          className={activeDep === '12 PM - 6 PM' ? "appendBottom12 filterTimeSlots activeTime" : "appendBottom12 filterTimeSlots"}>

                          <img className="checkBlockIcon" src='images/evening_inactive.webp' alt='' />
                          <div className="boldFont"><b>12</b> PM - <b>6</b> PM</div>
                        </div>
                        <div
                          onClick={() => {
                            setFlighDetails({
                              ...flightDetails,
                              pickupTime: 'after 6 PM',
                            })
                            setActiveDep('after 6 PM')
                          }}
                          className={activeDep === 'after 6 PM' ? "appendBottom12 filterTimeSlots activeTime" : "appendBottom12 filterTimeSlots"}>

                          <img className="checkBlockIcon" src='images/night_inactive.webp' alt='' />
                          <div className="boldFont">After <br /><b>6</b> PM</div>
                        </div>
                      </div>                    </div>
                  </div>
                  <div className="col-md-6 col-lg-2 dateCol">
                    <div className="form-border-transparent form-fs-lg bg-light rounded-3 h-100 p-3">
                      <label className="mb-1">
                        <i className="fa-solid fa-calendar"></i> Departure Date
                      </label>
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DemoContainer components={['DatePicker']}>
                          <DatePicker
                            label="Select Date"
                            minDate={tomorrow}
                            slotProps={{ textField: { size: 'small' } }}
                            value={flightDetails.departureDate}
                            onChange={(newValue) => {
                              const date = new Date(newValue['$d'])

                              setFlighDetails({
                                ...flightDetails,
                                departureDate: date,
                              })
                            }}
                          />
                        </DemoContainer>
                      </LocalizationProvider>
                    </div>
                  </div>
                  <div className="col-md-6 col-lg-2 dateCol">
                    <div className="form-border-transparent form-fs-lg bg-light rounded-3 h-100 p-3">
                      <label className="mb-1">
                        <i className="fa-solid fa-calendar"></i> Return Time
                      </label>
                      <div className="timeSlotsOuter">
                        <div
                          onClick={() => {


                            setFlighDetails({
                              ...flightDetails,
                              returnTime: 'before 6 AM',
                            })

                            setActiveReturn('before 6 AM')
                          }}
                          className={activeReturn === 'before 6 AM' ? "appendBottom12 filterTimeSlots activeTime" : "appendBottom12 filterTimeSlots"}>
                          <img className="checkBlockIcon" src='images/morning_inactive.webp' alt='' />
                          <div className="boldFont">Before <b>6</b> AM</div>
                        </div>
                        <div
                          onClick={() => {

                            setFlighDetails({
                              ...flightDetails,
                              returnTime: '6 AM - 12 PM',
                            })
                            setActiveReturn('6 AM - 12 PM')

                          }}
                          className={activeReturn === '6 AM - 12 PM' ? "appendBottom12 filterTimeSlots activeTime" : "appendBottom12 filterTimeSlots"}>

                          <img className="checkBlockIcon" src='images/noon_inactive.webp' alt='' />
                          <div className="boldFont"><b>6</b> AM - <b>12</b> PM</div>
                        </div>
                        <div
                          onClick={() => {
                            setFlighDetails({
                              ...flightDetails,
                              returnTime: '12 PM - 6 PM',
                            })
                            setActiveReturn('12 PM - 6 PM')
                          }}
                          className={activeReturn === '12 PM - 6 PM' ? "appendBottom12 filterTimeSlots activeTime" : "appendBottom12 filterTimeSlots"}>

                          <img className="checkBlockIcon" src='images/evening_inactive.webp' alt='' />
                          <div className="boldFont"><b>12</b> PM - <b>6</b> PM</div>
                        </div>
                        <div
                          onClick={() => {
                            setFlighDetails({
                              ...flightDetails,
                              returnTime: 'after 6 PM',
                            })
                            setActiveReturn('after 6 PM')
                          }}
                          className={activeReturn === 'after 6 PM' ? "appendBottom12 filterTimeSlots activeTime" : "appendBottom12 filterTimeSlots"}>

                          <img className="checkBlockIcon" src='images/night_inactive.webp' alt='' />
                          <div className="boldFont">After <br /><b>6</b> PM</div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6 col-lg-2 dateCol">
                    <div className="form-border-transparent form-fs-lg bg-light rounded-3 h-100 p-3">
                      <label className="mb-1">
                        <i className="fa-solid fa-calendar"></i> Return Date
                      </label>
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DemoContainer components={['DatePicker']}>
                          <DatePicker
                            label="Select Date"
                            minDate={dayjs(flightDetails?.departureDate)}
                            slotProps={{ textField: { size: 'small' } }}
                            value={flightDetails.returnDate}
                            onChange={(newValue) => {
                              const date = new Date(newValue['$d'])

                              setFlighDetails({
                                ...flightDetails,
                                returnDate: date,
                              })
                            }}
                          />
                        </DemoContainer>
                      </LocalizationProvider>
                    </div>
                  </div>
                  <div className="col-12 text-end">
                    <button onClick={submit} className="btn btn-primary mb-n4">
                      Book Now <i className="fa-solid fa-arrow-right"></i>
                    </button>
                  </div>
                </div>
              </CustomTabPanel>
            </Box>
          </div>
        </div>
      </section>

      <section className="specialOffers">
        <div className="container">
          <div className="row mb-5">
            <div className="col-10">
              <h4 className="mb-0 title">International Packages</h4>
            </div>
            <div className="col-2 text-end">
              <Link to="/tours/International" className="btn btn-lg btn-dark mb-0">View All</Link>
            </div>
          </div>
          <div>
            <Carousel
              responsive={destination}
              infinite={true}
              autoPlay={true}
              autoPlaySpeed={2000}
            >
              {tourInternationalData?.map((items) => (
                <div onClick={() => {
                  navigate(`/tourDetail/${items?._id}`)
                }}

                  key={items?._id} className="destination">
                  <Box className="eximg-group g-bg-4 tourIm">
                    <img className="" src={items?.images?.[0]} alt='' />
                    {/* <h6 className="mb-0 rating">4.3 <i className="fa-solid fa-star"></i></h6> */}
                  </Box>
                  <div className='py-2'>
                    <div className="py-2">
                      <h5 className="card-title">
                        <a href="#!">{items?.city} </a>
                      </h5>
                    </div>
                    <div className="hstack gap-2">
                      <span className="h5 mb-0 text-success">₹ {items?.price}</span>
                      <small>Starting price</small>
                    </div>
                  </div>
                </div>
              ))}
              {/* <div className="destination">
                <Box className="eximg-group g-bg-4 tourIm">
                  <img className="" src='images/thailand.jpg' alt='' />
                  <h6 className="mb-0 rating">4.3 <i className="fa-solid fa-star"></i></h6>
                </Box>
                <div className='py-2'>
                  <div className="py-2">
                    <h5 className="card-title">
                      <a href="#!">Lombok, Indonesia</a>
                    </h5>
                  </div>
                  <div className="hstack gap-2">
                    <span className="h5 mb-0 text-success">$1385</span>
                    <small>Starting price</small>
                  </div>
                </div>
              </div>
              <div className="destination">
                <Box className="eximg-group g-bg-4 tourIm">
                  <img className="" src='images/thailand.jpg' alt='' />
                  <h6 className="mb-0 rating">4.3 <i className="fa-solid fa-star"></i></h6>
                </Box>
                <div className='py-2'>
                  <div className="py-2">
                    <h5 className="card-title">
                      <a href="#!">Lombok, Indonesia</a>
                    </h5>
                  </div>
                  <div className="hstack gap-2">
                    <span className="h5 mb-0 text-success">$1385</span>
                    <small>Starting price</small>
                  </div>
                </div>
              </div>
              <div className="destination">
                <Box className="eximg-group g-bg-4 tourIm">
                  <img className="" src='images/thailand.jpg' alt='' />
                  <h6 className="mb-0 rating">4.3 <i className="fa-solid fa-star"></i></h6>
                </Box>
                <div className='py-2'>
                  <div className="py-2">
                    <h5 className="card-title">
                      <a href="#!">Lombok, Indonesia</a>
                    </h5>
                  </div>
                  <div className="hstack gap-2">
                    <span className="h5 mb-0 text-success">$1385</span>
                    <small>Starting price</small>
                  </div>
                </div>
              </div>
              <div className="destination">
                <Box className="eximg-group g-bg-4 tourIm">
                  <img className="" src='images/thailand.jpg' alt='' />
                  <h6 className="mb-0 rating">4.3 <i className="fa-solid fa-star"></i></h6>
                </Box>
                <div className='py-2'>
                  <div className="py-2">
                    <h5 className="card-title">
                      <a href="#!">Lombok, Indonesia</a>
                    </h5>
                  </div>
                  <div className="hstack gap-2">
                    <span className="h5 mb-0 text-success">$1385</span>
                    <small>Starting price</small>
                  </div>
                </div>
              </div> */}
            </Carousel>
          </div >
        </div>
      </section>

      <section className='specialOffers'>
        <div className='container'>
          <div className="row mb-5">
            <div className="col-10">
              <h4 className="mb-0 title">Domestic Packages</h4>
            </div>
            <div className="col-2 text-end">
              <Link to="/tours/Domestic" className="btn btn-lg btn-dark mb-0">View All</Link>
            </div>
          </div>
          <div>
            <Carousel
              responsive={destination}
              infinite={true}
              autoPlay={true}
              autoPlaySpeed={2000}
            >
              {tourData?.map((items) => (
                <div onClick={() => {
                  navigate(`/tourDetail/${items?._id}`)
                }}

                  key={items?._id} className="destination">
                  <Box className="eximg-group g-bg-4 tourIm">
                    <img className="" src={items?.images?.[0]} alt='' />
                    {/* <h6 className="mb-0 rating">4.3 <i className="fa-solid fa-star"></i></h6> */}
                  </Box>
                  <div className='py-2'>
                    <div className="py-2">
                      <h5 className="card-title">
                        <a href="#!">{items?.city} , India</a>
                      </h5>
                    </div>
                    <div className="hstack gap-2">
                      <span className="h5 mb-0 text-success">₹ {items?.price}</span>
                      <small>Starting price</small>
                    </div>
                  </div>
                </div>
              ))}
              {/* <div className="destination">
                <Box className="eximg-group g-bg-4 tourIm">
                  <img className="" src='images/thailand.jpg' alt='' />
                  <h6 className="mb-0 rating">4.3 <i className="fa-solid fa-star"></i></h6>
                </Box>
                <div className='py-2'>
                  <div className="py-2">
                    <h5 className="card-title">
                      <a href="#!">Lombok, Indonesia</a>
                    </h5>
                  </div>
                  <div className="hstack gap-2">
                    <span className="h5 mb-0 text-success">$1385</span>
                    <small>Starting price</small>
                  </div>
                </div>
              </div>
              <div className="destination">
                <Box className="eximg-group g-bg-4 tourIm">
                  <img className="" src='images/thailand.jpg' alt='' />
                  <h6 className="mb-0 rating">4.3 <i className="fa-solid fa-star"></i></h6>
                </Box>
                <div className='py-2'>
                  <div className="py-2">
                    <h5 className="card-title">
                      <a href="#!">Lombok, Indonesia</a>
                    </h5>
                  </div>
                  <div className="hstack gap-2">
                    <span className="h5 mb-0 text-success">$1385</span>
                    <small>Starting price</small>
                  </div>
                </div>
              </div>
              <div className="destination">
                <Box className="eximg-group g-bg-4 tourIm">
                  <img className="" src='images/thailand.jpg' alt='' />
                  <h6 className="mb-0 rating">4.3 <i className="fa-solid fa-star"></i></h6>
                </Box>
                <div className='py-2'>
                  <div className="py-2">
                    <h5 className="card-title">
                      <a href="#!">Lombok, Indonesia</a>
                    </h5>
                  </div>
                  <div className="hstack gap-2">
                    <span className="h5 mb-0 text-success">$1385</span>
                    <small>Starting price</small>
                  </div>
                </div>
              </div>
              <div className="destination">
                <Box className="eximg-group g-bg-4 tourIm">
                  <img className="" src='images/thailand.jpg' alt='' />
                  <h6 className="mb-0 rating">4.3 <i className="fa-solid fa-star"></i></h6>
                </Box>
                <div className='py-2'>
                  <div className="py-2">
                    <h5 className="card-title">
                      <a href="#!">Lombok, Indonesia</a>
                    </h5>
                  </div>
                  <div className="hstack gap-2">
                    <span className="h5 mb-0 text-success">$1385</span>
                    <small>Starting price</small>
                  </div>
                </div>
              </div> */}
            </Carousel>
          </div >
        </div >
      </section >

      <section className='specialOffers'>
        <div className='container'>
          <div className="bg-light rounded-3 position-relative p-4 p-sm-5">
            <div className="row align-items-center position-relative dicoverSec">
              <div className="col-lg-8">
                <div className="d-flex">
                  <h3>It's time to discover</h3>
                  <img src="images/04-DrYI6v5l.svg" className="h-40px ms-3" alt="" />
                </div>
                <p className="mb-3 mb-lg-0">Lorem Ipsum is simply dummy text of the printing and typesetting industry.  </p>
              </div>
              <div className="col-lg-4 text-lg-end"><Link to="/tour" className="btn btn-lg btn-dark mb-0">Book Now</Link></div>
            </div>
          </div>
        </div>
      </section>

      <section className='specialOffers'>
        <div className='container'>
          <div className="row mb-5">
            <div className="col-12">
              <h4 className="mb-0 title">Top Categories</h4>
            </div>
          </div>
          <div className="row g-4 g-xl-5 topCate">
            <div className="col-sm-6 col-lg-4 col-xl-3"
              onClick={() => {
                navigate(`/tour/Adventure`)
              }}
            >
              <div className="row g-2 g-md-3 align-items-center position-relative">
                <div className="col-md-6"><img src="images/19-BYcWTs_B.jpg" className="rounded-3" alt="" /></div>
                <div className="col-md-6">
                  <div className="p-2 p-md-0">
                    <h5 className="mb-1"><a href="#" className="stretched-link">Adventure</a></h5>
                    {/* <span>2845 Places</span> */}
                  </div>
                </div>
              </div>
            </div>
            <div className="col-sm-6 col-lg-4 col-xl-3"
              onClick={() => {
                navigate(`/tour/SoundScape`)
              }}
            >
              <div className="row g-2 g-md-3 align-items-center position-relative">
                <div className="col-md-6"><img src="images/13-CeWMv36_.jpg" className="rounded-3" alt="" /></div>
                <div className="col-md-6">
                  <div className="p-2 p-md-0">
                    <h5 className="mb-1"><a href="#" className="stretched-link">Sound Scape</a></h5>
                    {/* <span>2845 Places</span> */}
                  </div>
                </div>
              </div>
            </div>
            <div className="col-sm-6 col-lg-4 col-xl-3"
              onClick={() => {
                navigate(`/tour/Desert`)
              }}
            >
              <div className="row g-2 g-md-3 align-items-center position-relative">
                <div className="col-md-6"><img src="images/18-C_X3yjnw.jpg" className="rounded-3" alt="" /></div>
                <div className="col-md-6">
                  <div className="p-2 p-md-0">
                    <h5 className="mb-1"><a href="#" className="stretched-link">Desert</a></h5>
                    {/* <span>1587 Places</span> */}
                  </div>
                </div>
              </div>
            </div>
            <div className="col-sm-6 col-lg-4 col-xl-3"
              onClick={() => {
                navigate(`/tour/Pilgrims`)
              }}
            >
              <div className="row g-2 g-md-3 align-items-center position-relative">
                <div className="col-md-6"><img src="images/19-BYcWTs_B.jpg" className="rounded-3" alt="" /></div>
                <div className="col-md-6">
                  <div className="p-2 p-md-0">
                    <h5 className="mb-1"><a href="#" className="stretched-link">Pilgrims</a></h5>
                    {/* <span>2845 Places</span> */}
                  </div>
                </div>
              </div>
            </div>
            <div className="col-sm-6 col-lg-4 col-xl-3"
              onClick={() => {
                navigate(`/tour/History`)
              }}
            >
              <div className="row g-2 g-md-3 align-items-center position-relative">
                <div className="col-md-6"><img src="images/17-E7K6iGPB.jpg" className="rounded-3" alt="" /></div>
                <div className="col-md-6">
                  <div className="p-2 p-md-0">
                    <h5 className="mb-1"><a href="#" className="stretched-link">History</a></h5>
                    {/* <span>986 Places</span> */}
                  </div>
                </div>
              </div>
            </div>
            <div className="col-sm-6 col-lg-4 col-xl-3"
              onClick={() => {
                navigate(`/tour/IslandHopper`)
              }}
            >
              <div className="row g-2 g-md-3 align-items-center position-relative">
                <div className="col-md-6"><img src="images/14-fpi-ZIwa.jpg" className="rounded-3" alt="" /></div>
                <div className="col-md-6">
                  <div className="p-2 p-md-0">
                    <h5 className="mb-1"><a href="#" className="stretched-link">IslandHopper</a></h5>
                    {/* <span>786 Places</span> */}
                  </div>
                </div>
              </div>
            </div>
            <div className="col-sm-6 col-lg-4 col-xl-3"
              onClick={() => {
                navigate(`/tour/General`)
              }}
            >
              <div className="row g-2 g-md-3 align-items-center position-relative">
                <div className="col-md-6"><img src="images/16-D1cIRfhu.jpg" className="rounded-3" alt="" /></div>
                <div className="col-md-6">
                  <div className="p-2 p-md-0">
                    <h5 className="mb-1"><a href="#" className="stretched-link">General</a></h5>
                    {/* <span>786 Places</span> */}
                  </div>
                </div>
              </div>
            </div>
            <div className="col-sm-6 col-lg-4 col-xl-3"
              onClick={() => {
                navigate(`/tour/Haunted`)
              }}
            >
              <div className="row g-2 g-md-3 align-items-center position-relative">
                <div className="col-md-6"><img src="images/15-CGaqJfSo.jpg" className="rounded-3" alt="" /></div>
                <div className="col-md-6">
                  <div className="p-2 p-md-0">
                    <h5 className="mb-1"><a href="#" className="stretched-link">Haunted</a></h5>
                    {/* <span>568 Places</span> */}
                  </div>
                </div>
              </div>
            </div>
            {/* <div className="col-sm-6 col-lg-4 col-xl-3">
              <div className="row g-2 g-md-3 align-items-center position-relative">
                <div className="col-md-6"><img src="images/14-fpi-ZIwa.jpg" className="rounded-3" alt="" /></div>
                <div className="col-md-6">
                  <div className="p-2 p-md-0">
                    <h5 className="mb-1"><a href="#" className="stretched-link">Temple</a></h5>
                    <span>256 Places</span>
                  </div>
                </div>
              </div>
            </div> */}
            {/* <div className="col-sm-6 col-lg-4 col-xl-3">
              <div className="row g-2 g-md-3 align-items-center position-relative">
                <div className="col-md-6"><img src="images/13-CeWMv36_.jpg" className="rounded-3" alt="" /></div>
                <div className="col-md-6">
                  <div className="p-2 p-md-0">
                    <h5 className="mb-1"><a href="#" className="stretched-link">Festival</a></h5>
                    <span>654 Places</span>
                  </div>
                </div>
              </div>
            </div> */}
          </div>
        </div>
      </section>

      {/* <section className='specialOffers'>
        <div className='container'>
          <div className="row mb-5">
            <div className="col-12">
              <h4 className="mb-0 title">Explore Top Destinations</h4>
            </div>
          </div>
          <div>
            <Carousel
              responsive={destination}
              infinite={true}
              autoPlay={true}
              autoPlaySpeed={2000}
            >
              <div className="destination">
                <Box className="eximg-group g-bg-4">
                  <img className="" src="images/thailand.jpg" alt="" />
                </Box>
                <div className="py-2">
                  <div className="d-flex justify-content-between align-items-center">
                    <h5 className="card-title">
                      <a href="#!">Thailand</a>
                    </h5>
                    <h6 className="mb-0 rating">
                      4.3 <i className="fa-solid fa-star"></i>
                    </h6>
                  </div>
                  <span className="mb-0">The next flight is on 26th Dec</span>
                </div>
              </div>
              <div className="destination">
                <Box className="eximg-group g-bg-4">
                  <img className="" src="images/thailand.jpg" alt="" />
                </Box>
                <div className="py-2">
                  <div className="d-flex justify-content-between align-items-center">
                    <h5 className="card-title">
                      <a href="#!">Thailand</a>
                    </h5>
                    <h6 className="mb-0 rating">
                      4.3 <i className="fa-solid fa-star"></i>
                    </h6>
                  </div>
                  <span className="mb-0">The next flight is on 26th Dec</span>
                </div>
              </div>
              <div className="destination">
                <Box className="eximg-group g-bg-4">
                  <img className="" src="images/thailand.jpg" alt="" />
                </Box>
                <div className="py-2">
                  <div className="d-flex justify-content-between align-items-center">
                    <h5 className="card-title">
                      <a href="#!">Thailand</a>
                    </h5>
                    <h6 className="mb-0 rating">
                      4.3 <i className="fa-solid fa-star"></i>
                    </h6>
                  </div>
                  <span className="mb-0">The next flight is on 26th Dec</span>
                </div>
              </div>
              <div className="destination">
                <Box className="eximg-group g-bg-4">
                  <img className="" src="images/thailand.jpg" alt="" />
                </Box>
                <div className="py-2">
                  <div className="d-flex justify-content-between align-items-center">
                    <h5 className="card-title">
                      <a href="#!">Thailand</a>
                    </h5>
                    <h6 className="mb-0 rating">
                      4.3 <i className="fa-solid fa-star"></i>
                    </h6>
                  </div>
                  <span className="mb-0">The next flight is on 26th Dec</span>
                </div>
              </div>
              <div className="destination">
                <Box className="eximg-group g-bg-4">
                  <img className="" src="images/thailand.jpg" alt="" />
                </Box>
                <div className="py-2">
                  <div className="d-flex justify-content-between align-items-center">
                    <h5 className="card-title">
                      <a href="#!">Thailand</a>
                    </h5>
                    <h6 className="mb-0 rating">
                      4.3 <i className="fa-solid fa-star"></i>
                    </h6>
                  </div>
                  <span className="mb-0">The next flight is on 26th Dec</span>
                </div>
              </div>
            </Carousel>
          </div>
        </div>
      </section>
      <section className="specialOffers">
        <div className="container">
          <div className="row g-4 g-lg-5 justify-content-center stepSec">
            <div className="col-sm-6 col-md-4 text-center position-relative">
              <i className="fa-solid fa-arrow-trend-down"></i>
              <div className="px-5">
                <img src="images/step-3.svg" className="w-150px mb-3" alt="" />
                <h5>Search Choice</h5>
                <p className="mb-0">
                  Total's 630 + destinations that we work with
                </p>
              </div>
            </div>
            <div className="col-sm-6 col-md-4 position-relative text-center pt-0 pt-lg-5">
              <i className="fa-solid fa-arrow-trend-up"></i>
              <div className="px-5">
                <img src="images/step-2.svg" className="w-150px mb-3" alt="" />
                <h5>Select Destination</h5>
                <p className="mb-0">
                  Insipidity the sufficient discretion imprudence
                </p>
              </div>
            </div>
            <div className="col-sm-6 col-md-4 text-center">
              <div className="px-5">
                <img src="images/step-1.svg" className="w-150px mb-3" alt="" />
                <h5>Easy to Book</h5>
                <p className="mb-0">
                  With an easy and fast ticket purchase process
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="specialOffers">
        <div className="container">
          <div className="bg-light rounded-3 position-relative p-4 p-sm-5">
            <div className="row align-items-center position-relative dicoverSec">
              <div className="col-lg-8">
                <div className="d-flex">
                  <h3>It's time to discover</h3>
                  <img
                    src="images/04-DrYI6v5l.svg"
                    className="h-40px ms-3"
                    alt=""
                  />
                </div>
                <p className="mb-3 mb-lg-0">
                  He moonlights difficult engrossed it, sportsmen. Interested
                  has all Devonshire difficulty gay assistance joy.{' '}
                </p>
              </div>
              <div className="col-lg-4 text-lg-end">
                <Link to="/signRegister" className="btn btn-lg btn-dark mb-0">
                  Book a Flight
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="specialOffers">
        <div className="container">
          <div className="row mb-5">
            <div className="col-12">
              <h4 className="mb-0 title">Read Blogs</h4>
            </div>
          </div>
          <div className="row g-4 g-xl-5 justify-content-between blogs">
            <div className="col-md-6">
              <div className="card bg-transparent">
                <img src="images/01-MhAPPZx6.jpg" className="card-img" alt="" />
                <div className="card-body px-3">
                  <h4>
                    <a href="#!">
                      10 Ways on How to Improve your Hotel Operations{' '}
                    </a>
                  </h4>
                </div>
              </div>
            </div>
            <div className="col-md-6 cardSec">
              <div className="card bg-transparent mb-4 mb-md-5">
                <div className="row align-items-center">
                  <div className="col-sm-4">
                    <img
                      src="images/02-eN-TCkPc.jpg"
                      className="card-img"
                      alt=""
                    />
                  </div>
                  <div className="col-sm-8">
                    <div className="card-body p-sm-0">
                      <h5 className="card-title">
                        <a href="#!">Story of water world adventure</a>
                      </h5>
                      <p className="mb-0">Jacqueline Miller</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="card bg-transparent mb-4 mb-md-5">
                <div className="row align-items-center">
                  <div className="col-sm-4">
                    <img
                      src="images/03-CsrralM0.jpg"
                      className="card-img"
                      alt=""
                    />
                  </div>
                  <div className="col-sm-8">
                    <div className="card-body p-sm-0">
                      <h5 className="card-title">
                        <a href="#!">
                          How Hotel Technology Can Help Small Hotel Businesses
                        </a>
                      </h5>
                      <p className="mb-0">Frances Guerrero</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="card bg-transparent mb-4 mb-md-5">
                <div className="row align-items-center">
                  <div className="col-sm-4">
                    <img
                      src="images/04-BUUYY-AN.jpg"
                      className="card-img"
                      alt=""
                    />
                  </div>
                  <div className="col-sm-8">
                    <div className="card-body p-sm-0">
                      <h5 className="card-title">
                        <a href="#!">
                          Hotel Service - Become a Guide for Your Guests
                        </a>
                      </h5>
                      <p className="mb-0">Louis Ferguson</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section> */}
      <ToastContainer />
      <Footer />
    </>
  )
}

export default Train

const classes = [
  { label: 'Economy', value: 'Economy' },
  { label: 'Business', value: 'Business' },
  { label: 'First', value: 'First' },
  { label: 'Premium Economy', value: 'Premium Economy' },
  { label: 'Premium Business', value: 'Premium Business' },
  { label: 'Premium First', value: 'Premium First' },
]
const types = [
  { label: 'Economy', value: 'Economy' },
  { label: 'Bussiness', value: 'Bussiness' },
]

const trainTypes = [
  'All Classes',
  'Anubhuti Class (EA)',
  'AC First Class (1A)',
  'Vistadome AC (EV)',
  'Exec. Chair Car (EC)',
  'AC 2 Tier (2A)',
  'First Class (FC)',
  'AC 3 Tier (3A)',
  'AC 3 Economy (3E)',
  'Vistadome Chair Car (VC)',
  'AC Chair car (CC)',
  'Sleeper (SL)',
  'Vistadome Non AC (VS)',
  'Second Sitting (2S)',
]
const flightTypes = [
  { label: 'All Classes', value: 'All Classes' },
  { label: 'Anubhuti Class (EA)', value: 'Anubhuti Class (EA)' },
  { label: 'AC First Class (1A)', value: 'AC First Class (1A)' },
  { label: 'Vistadome AC (EV)', value: 'Vistadome AC (EV)' },
  { label: 'Exec. Chair Car (EC)', value: 'Exec. Chair Car (EC)' },
  { label: 'AC 2 Tier (2A)', value: 'AC 2 Tier (2A)' },
  { label: 'First Class (FC)', value: 'First Class (FC)' },
  { label: 'AC 3 Tier (3A)', value: 'AC 3 Tier (3A)' },
  { label: 'AC 3 Economy (3E)', value: 'AC 3 Economy (3E)' },
  { label: 'Vistadome Chair Car (VC)', value: 'Vistadome Chair Car (VC)' },
  { label: 'AC Chair car (CC)', value: 'AC Chair car (CC)' },
  { label: 'Sleeper (SL)', value: 'Sleeper (SL)' },
  { label: 'Vistadome Non AC (VS)', value: 'Vistadome Non AC (VS)' },
  { label: 'Second Sitting (2S)', value: 'Second Sitting (2S)' },
]
